import { Collection } from "@datx/core";
import { jsonapi } from "@datx/jsonapi";
import LoadStatus from "../models/loadStatus";
import Property from "../models/property";

export default class PropertyStore extends jsonapi(Collection) {
  static types = [Property, LoadStatus];
}